import { Controller } from "@hotwired/stimulus"
import moment from "moment-timezone/moment-timezone"
import "moment-timezone/moment-timezone-utils"
import { get } from "@rails/request.js"

// Connects to data-controller="admin--date-range-chooser"
export default class extends Controller {
  initialize() {
    moment.tz.add("EST|EST|50|0|")
  }

  connect() {
    this.bindElements()
  }

  bindElements() {
    let $endDate, $startDate
    if ($("#mode-selector").data("default-start")) {
      $startDate = $("#mode-selector").data("default-start")
    } else {
      $startDate = moment().tz("EST").subtract(29, "days")
    }

    if ($("#mode-selector").data("default-end")) {
      $endDate = $("#mode-selector").data("default-end")
    } else {
      $endDate = moment().tz("EST")
    }

    $("#report_range").daterangepicker(
      {
        opens: "left",
        startDate: $startDate,
        endDate: $endDate,
        ranges: {
          Today: [moment().tz("EST"), moment().tz("EST")],
          Yesterday: [
            moment().tz("EST").subtract(1, "days"),
            moment().tz("EST").subtract(1, "days"),
          ],
          "Last 7 Days": [
            moment().tz("EST").subtract(6, "days"),
            moment().tz("EST"),
          ],
          "Last 30 Days": [
            moment().tz("EST").subtract(29, "days"),
            moment().tz("EST"),
          ],
          "This Month": [
            moment().tz("EST").startOf("month"),
            moment().tz("EST").endOf("month"),
          ],
          "Last Month": [
            moment().tz("EST").subtract(1, "month").startOf("month"),
            moment().tz("EST").subtract(1, "month").endOf("month"),
          ],
          Lifetime: [
            $("#mode-selector").data("lifetime-start")
              ? $("#mode-selector").data("lifetime-start")
              : "4/25/2012",
            moment().tz("EST"),
          ],
        },
      },
      (start, end) => {
        let history_url, mode, target_url
        if ($("#mode-selector li.l")) {
          mode = $("#mode-selector li.l").data("mode")
        } else {
          mode = "day"
        }
        $("#mode-selector").data("start-date", start.format("YYYY-MM-DD"))
        $("#mode-selector").data("end-date", end.format("YYYY-MM-DD"))
        $("#report_range span").html(
          start.format("MMMM D, YYYY") + " - " + end.format("MMMM D, YYYY")
        )

        // Set date in url
        if ($("#mode-selector").data("target-url")) {
          target_url = $("#mode-selector").data("target-url")
          history_url = $("#mode-selector").data("target-url")
        } else {
          target_url = "/admin/stats/stats"
          history_url = "/admin/stats/" + $("#template").val()
        }

        history_url =
          history_url +
          "?start_date=" +
          start.format("YYYY-MM-DD") +
          "&end_date=" +
          end.format("YYYY-MM-DD") +
          "&filter=" +
          $("#mode-selector").data("filter")
        history.pushState(null, null, history_url)

        return this.loadPage(start, end, mode, target_url)
      }
    )

    return $("#mode-selector li").click(e => {
      $("#mode-selector li").removeClass("l")
      $(e.target).addClass("l")
      const parent = $(e.target).closest("ul")
      const mode = $(e.target).data("mode")
      const target_url = parent.data("target-url")

      return this.loadPage(
        moment(parent.data("start-date")),
        moment(parent.data("end-date")),
        mode,
        target_url
      )
    })
  }

  loadPage(start_date, end_date, mode, target_url) {
    mode = typeof mode === "undefined" ? "day" : mode
    const url = target_url +
      "?start_date=" +
      start_date.format("YYYY-MM-DD") +
      "&end_date=" +
      end_date.format("YYYY-MM-DD") +
      "&template=" +
      $("#mode-selector").data("template") +
      "&filter=" +
      $("#mode-selector").data("filter") +
      "&mode=" +
      mode

    get(`${url}`, {
      responseKind: "turbo-stream",
    })
  }
}
